module.exports = __webpack_public_path__ + "static/img/2456_phase_function_Paper_Points.b8c9942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2456_phase_function_Paper_Points.png
// module id = jbvS
// module chunks = 0